// extracted by mini-css-extract-plugin
export default {"container":"_2w00p","header":"_18hdX"};